import type { Dispatch, SetStateAction } from 'react';
import { useEffect } from 'react';

import { Flex } from '@/components/Flex';
import { HeaderInfo } from '@/components/Header/components';
import type { ContentfulMainHeaderFragment } from '@/graphql/contentful/api';
import { useHeaderOffSet } from '@/hooks/useHeaderOffSet';
import { useIsMdDown } from '@/hooks/useMedia';
import type { HeaderThemeKeys } from '@/theme/types/components';

import { MobileNav } from '../MobileNav';

import * as S from './MobileMenu.styles';

export interface MobileMenuProps {
  headerBackground: HeaderThemeKeys;
  hideLanguageSwitcher?: boolean;
  hidePhone?: boolean;
  hideSearch?: boolean;
  isMobileMenuOpen: boolean;
  isOpen: boolean;
  items: Partial<ContentfulMainHeaderFragment>;
  onClose: (isOpen: boolean) => void;
  setShoppingBagDrawerOpen: Dispatch<SetStateAction<boolean>>;
  shoppingBagDrawerOpen: boolean;
}

export const MobileMenu = ({
  headerBackground,
  hideLanguageSwitcher,
  hidePhone,
  hideSearch,
  isMobileMenuOpen,
  isOpen,
  items,
  onClose,
  setShoppingBagDrawerOpen,
  shoppingBagDrawerOpen,
}: MobileMenuProps) => {
  const top = useHeaderOffSet();
  const isMdDown = useIsMdDown();
  useEffect(() => {
    if (shoppingBagDrawerOpen && !isMdDown) {
      const mainContent = document.querySelector('main');
      const footer = document.querySelector('footer');
      if (mainContent) mainContent.style.display = 'none';
      if (footer) footer.style.display = 'none';
    } else {
      const mainContent = document.querySelector('main');
      const footer = document.querySelector('footer');
      if (mainContent) mainContent.style.display = 'block';
      if (footer) footer.style.display = 'block';
    }
  }, [shoppingBagDrawerOpen]);

  return (
    <S.Wrapper data-test-id='MobileMenuWrapper' isOpen={isOpen} top={top}>
      <Flex as='nav' flexDirection='column'>
        <MobileNav
          data-test-id='MobileMenuMobileNav'
          items={items as ContentfulMainHeaderFragment}
          onClose={onClose}
          top={!isMdDown ? top : 0}
        />
      </Flex>
      <S.BottomMenu data-test-id='MobileMenuBottomMenu'>
        <HeaderInfo
          data-test-id='MobileMenuHeaderInfo'
          headerBackground={headerBackground}
          hideLanguageSwitcher={hideLanguageSwitcher}
          hidePhone={hidePhone}
          hideSearch={hideSearch}
          isMobileFooter={true}
          isMobileMenuOpen={isMobileMenuOpen}
          onMobileMenuHandler={() => onClose(false)}
          onShoppingBagDrawerHandler={setShoppingBagDrawerOpen}
        />
      </S.BottomMenu>
    </S.Wrapper>
  );
};

MobileMenu.displayName = 'Aside';
